<template lang="pug">
.footprint
  .title {{$t('me.footprint.title')}}
  .subtitle {{$t('me.footprint.subtitle')}}
  .content
    foot-slides
    //transition(name="fade")
      .card
        img(src="~assets/footprint/5g.png")
        //.copy DAMO 5G赛车漂移
        //.download-btn 下载
  //.slides
    footprint-picker


  
</template>
<script>
import DatePicker from '@/components/res/DatePicker'
import Flex from '@/components/Flex'
import { mapMutations } from 'vuex'
import FootprintPicker from '@/components/me/FootprintPicker'
import FootSlides from '@/components/me/FootSlides'
import EmptyState from '@/components/wedgits/EmptyState'
export default {
  name: 'Footprint',
  components: { EmptyState, FootSlides, FootprintPicker, Flex, DatePicker },
  props: {},
  created() {},
  data() {
    return {
      timeTable: [],
    }
  },
  computed: {},
  methods: {
    ...mapMutations('app', ['setRouterBack']),
    onNext() {},
  },
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.footprint
  position: absolute
  width: 100%
  height: 100%
  .title
    margin-left: pxToRem(30)
  .subtitle
    margin-left: pxToRem(30)
  .content
    width: 100%
    margin-top: pxToRem(56)
    .card
      position: relative
      width: pxToRem(670)
      height: pxToRem(800)
      //background: #1664FF
      margin: auto
      border-radius: pxToRem(16)
      overflow: hidden
      img
        width: 100%
      .copy
        font-size: pxToRem(36)
        line-height: pxToRem(50)
        position: absolute
        bottom: pxToRem(50)
        left: pxToRem(40)
        color: #ffffff
      .download-btn
        position: absolute
        font-size: pxToRem(26)
        color: $cl-blue
        width: pxToRem(152)
        height: pxToRem(53)
        border-radius: pxToRem(26.5)
        background: #ffffff
        bottom: pxToRem(50)
        right: pxToRem(40)
        text-align: center
        line-height: pxToRem(53)
  .slides
    margin-top: pxToRem(30)
.slide-enter-active, .slide-leave-active
  transition: all 0.5s
.slide-enter, .slide-leave-to
  transform: translateX(-100%)
</style>
